import React from 'react'
import { propIs, or } from 'ramda'
import Icon from '../Icon'
import Days from '../Days'
import ListItem from '../ListItem'
import WindowTime from '../WindowTime'
import DaysInfo from '../DaysInfo'
import { ListWrap, ListTitle, StyledListSubtitle, ListTags, IconWrap, ListContainer } from '../ListItem/styled'

const ListItemContainer = ({ data, isEditMode, editContent, daysLength, filterDays }) => {
    const isWindowTime = propIs(Array, 'window_time')
    const isDays = propIs(Array, 'days')
    const isDaysInfo = or(propIs(Number, 'days-info'), propIs(String, 'days-info'))
    const isInfo = propIs(String, 'info')
    const isNights = propIs(Array, 'nights')
    const getPathname = item => {
        switch (item.row_type) {
            case 'obj': {
                return `/manage/zones/${item.row_no.split(' ').join('-').toLowerCase()}`
            }
            case 'cow': {
                return `/manage/herd/cow/${item.row_no}`
            }
            default:
                return '/monitoring'
        }
    }
    return (
        data.map(item => (
            <ListItem
                key={item.row_id}
                item={item}
                to={{
                    pathname: getPathname(item),
                    state: {
                        rowid: item.row_id
                    }
                }}
                bordercolor={item.bordercolor}
                isEditMode={isEditMode}
                editContent={editContent}
            >
                <ListContainer>
                    <ListWrap>
                        {
                            item.row_no &&
                            <ListTitle>{item.row_no}</ListTitle>
                        }
                        {
                            item.cow_info &&
                            <StyledListSubtitle>{item.cow_info}</StyledListSubtitle>
                        }
                        {
                            item.grp_name &&
                            <StyledListSubtitle>{item.grp_name}</StyledListSubtitle>
                        }
                        {
                            item.graceperiod &&
                            <>
                                <IconWrap>
                                    <Icon name="grace_period" color="#e65050" />
                                </IconWrap>
                                <ListTags bold red style={{ marginLeft: '5px' }}>
                                    {item.graceperiod}
                                </ListTags>
                            </>
                        }
                        {
                            item.warning > 0 &&
                            <IconWrap>
                                <Icon name="bell" />
                            </IconWrap>
                        }
                        {
                            item.alarm > 0 &&
                            <IconWrap>
                                <Icon name="alert" />
                            </IconWrap>
                        }
                        {
                            item.procreaction > 0 &&
                            <IconWrap>
                                <Icon name="procreation" />
                            </IconWrap>
                        }
                        {
                            (isDaysInfo(item) && item['days-info'] > 0) &&
                            <DaysInfo
                                color={item.bordercolor}
                                days={parseInt(item['days-info'], 10)}
                            />
                        }
                    </ListWrap>
                    {
                        isInfo(item) &&
                        <ListWrap>
                            <ListTags bold>
                                {item.info}
                            </ListTags>
                        </ListWrap>
                    }
                    {
                        isWindowTime(item) &&
                        <ListWrap>
                            <WindowTime
                                startTime={parseInt(item['window_time'][0])}
                                startTimeFormatted={item['window'] && item['window'][0]}
                                endTime={parseInt(item['window_time'][1])}
                                endTimeFormatted={item['window'] && item['window'][1]}
                            />
                        </ListWrap>
                    }
                    {
                        isDays(item) &&
                        <ListWrap>
                            <Days
                                daysLength={daysLength}
                                icon={isNights(item) ? 'day' : ''}
                                items={filterDays ? filterDays(item.days) : item.days}
                            />
                        </ListWrap>
                    }
                    {
                        isNights(item) &&
                        <ListWrap>
                            <Days
                                daysLength={daysLength}
                                icon='night'
                                items={filterDays ? filterDays(item.nights) : item.nights}
                            />
                        </ListWrap>
                    }
                </ListContainer>
            </ListItem>
        ))
    )
}

export default ListItemContainer
